/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql, Link } from "gatsby"
import "./bootstrap.min.css"
import "./layout.css"
import StickyBottom from "../components/stickybottom"
import { OutboundLink } from "gatsby-plugin-google-analytics"
import ReactGA from "react-ga"
import Img from "gatsby-image"

ReactGA.initialize("UA-140819444-1")

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query {
        placeholderImage: file(relativePath: { eq: "918Kiss.png" }) {
          childImageSharp {
            fluid(maxWidth: 450) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => (
      <>
        <div
          style={{
            margin: `0 auto`,
            maxWidth: 960,
            padding: `0px 1.0875rem 1.45rem`,
            paddingTop: 0,
          }}
        >
          <header>
            <div className="container">
              <div className="row pt-3 pb-2">
                <div className="col-lg-3 col-md-1" />
                <div className="col-sm-12 col-lg-6 col-md-9">
                  <Img fluid={data.placeholderImage.childImageSharp.fluid} />
                </div>
              </div>
            </div>
          </header>
          <main>{children}</main>
          <footer className="py-3 mb-4">
            <StickyBottom />© {new Date().getFullYear()}, Copyrighted by
            {` `}
            <Link className="link" to="/">
              Home
            </Link>
            {` · `}
            <OutboundLink href="https://www.megacafe888.com" className="link">
              918Kiss Malaysia
            </OutboundLink>
            {` · `}
            <Link className="link" to="/terms/">
              Terms of Use
            </Link>
            {` · `}
            <Link className="link" to="/privacy/">
              Privacy Policy
            </Link>
            {` · `}
            <Link className="link" to="/responsible-gaming/">
              Responsible Gaming
            </Link>
          </footer>
        </div>
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
